export default {
  isDefined: function (o) {
    return void 0 !== o && null !== o;
  },
  componentPropValidator: function (base, current) {
    return base.props
      ? Object.entries(base.props)
          .filter(([key, value]) => value.required)
          .reduce(
            (bool, [key, value]) =>
              bool &&
              Boolean(current.props[key]) &&
              current.props[key].type === value.type,
            true
          )
      : true;
  },
  normalizeSpace: function (str) {
    return str.trim().replace(/\s+/gm, ' ');
  },
};
